module.exports = __webpack_public_path__ + "img/quit_icon.c393467a.svg";